import { Routes } from '@angular/router';
import { AuthGuard } from 'src/app/auth/helpers';

export const DASHBOARD_ROUTES: Routes = [
  {
    path: 'home',
    loadComponent: () =>
      import('./home/home.component').then(m => m.HomeComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'emergency',
    loadComponent: () =>
      import('./emergency/emergency.component').then(m => m.EmergencyComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'help',
    loadComponent: () =>
      import('./driver-help/driver-help.component').then(
        m => m.DriverHelpComponent,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'tasks',
    loadComponent: () =>
      import('../task/components/tasks-list/tasks-list.component').then(
        m => m.TasksListComponent,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'late-checkout',
    loadComponent: () =>
      import('../task/components/task-checkout-reason/task-checkout-reason.component').then(
        m => m.TaskCheckoutReasonComponent,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'update-task-assignment',
    loadComponent: () =>
      import('../task/components/update-task-assignment/update-task-assignment.component').then(
        m => m.UpdateTaskAssignmentComponent,
      ),
    canActivate: [AuthGuard],
  },
];
